module.exports = __webpack_public_path__ + "static/media/instagram.af998216.png";